/**
 * Hình cái bàn.
 *
 * Bảng emoji không có cái bàn ăn nào — chỗ này trước đây mượn tạm cái ghế 🪑, mà nhìn vào
 * một sơ đồ bàn toàn ghế thì phải đọc chữ mới biết đang xem cái gì. Vẽ bằng nét thì đúng
 * là cái bàn, và đây là hình xuất hiện nhiều nhất trong cả app.
 *
 * Chủ quán chọn hình khác cho bàn của mình — cái cây, cái ghế sofa, con xe — thì giữ
 * nguyên emoji họ chọn. Chỉ cái ghế mặc định mới đổi thành bàn.
 */

/** Mã emoji cũ, giờ hiểu là "bàn mặc định". Dữ liệu của quán đang lưu đúng ký tự này. */
export const DEFAULT_TABLE_ICON = '🪑'

export function TableGlyph({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className ?? 'table-glyph'} aria-hidden="true" focusable="false">
      {/* Mặt bàn, rồi hai chân xoè ra — đủ để nhận ra mà không cần nhìn lâu. */}
      <rect x="2.4" y="7" width="19.2" height="3.1" rx="1.55" fill="currentColor" />
      <path
        d="M6.4 10.1 4.8 19.4M17.6 10.1 19.2 19.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
    </svg>
  )
}

/**
 * Ô hình của một cái bàn: emoji chủ quán chọn, hoặc hình bàn vẽ sẵn.
 *
 * `className` đi thẳng vào thẻ bọc ngoài để mỗi chỗ tự quyết cỡ và nền — ô tròn ở sơ đồ
 * bàn, ô vuông bo góc ở thẻ đơn, ô nhỏ trong danh sách chọn bàn.
 */
export function TableIcon({ icon, className }: { icon?: string | null; className?: string }) {
  const custom = icon && icon !== DEFAULT_TABLE_ICON

  return (
    <span className={className} aria-hidden="true">
      {custom ? icon : <TableGlyph />}
    </span>
  )
}
